import * as React from 'react';
import './orders-transactions.scss';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { Order } from 'core/domain';
import { Badge } from 'components';
import {
    CopyOutlined,
    DollarCircleOutlined,
    DownOutlined,
    EditOutlined,
    ExportOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
    confirmAndPayoutOrder,
    getAllOrders,
    getAllOrderStateTypes,
    getAllOrderTypes,
} from '../../../../core/repositories/orders-transactions';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
// import { ClientSidePagination } from "components/pagination/pagination";
import { Enum, PaginationList } from '../../../../core/domain/commons/common';
import moment from 'jalali-moment';
import { digitSperator, faNumToEnNum } from 'core/utils/decimalExtentions';
import { Dropdown } from 'components/dropdown/dropdown';
import { copyToClipboard } from 'core/utils/copyToClipboard';
import { getIconPath } from 'core/utils/getIconPath';
import { OrderEditModal } from './edit-modal/edit-modal';
import { OrderDetailModal } from './order-detail/order-detail';
import { Modal } from 'components/modal/modal';
import DatePicker from 'react-multi-date-picker';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { downloadCSV } from '../../../../core/utils/export-to-file';
import { BadgeType } from 'components/badge/badge';
import { getOrderTransactionStateBadgeType } from './script';
import { ConfirmBulkSelectModal } from './bulk-select-modal/bulk-select-modal';
import { getPageNum } from 'core/utils/paggingHelper';
import { Dropdown as AntdDropdown, Menu } from 'antd'
import { jFormat } from 'core/utils/jFormat';

interface FilterValues {
    search: string;
    state: Enum;
    type?: Enum;
    startDate: string;
    endDate: string;
}

const empty_filters = {
    search: '',
    state: {
        id: -1,
        title: 'همه وضعیت ها',
    },
    type: {
        id: -1,
        title: 'همه ',
    },
    startDate: '',
    endDate: '',
};

const actionItems: Enum[] = [
    {
        id: 0,
        title: "انتخاب عملیات",
    },
    {
        id: 100,
        title: "تایید و تسویه",
    },
];

export const OrdersTransactions: React.FC = () => {
    const [detailModalIsOpen, setDetailModalIsOpen] = React.useState<boolean>(false);

    const startDateRef = React.useRef();
    const endDateRef = React.useRef();

    const [selectedItem, setSelectedItem] = React.useState<Order>();
    const [confirmButtonLoading, setConfirmButtonLoading] = React.useState<boolean>(false);
    const [query, setQuery] = React.useState<string>('');
    const [editModalIsOpen, setEditModalIsOpen] = React.useState<boolean>(false);
    const [orderTypes, setOrderTypes] = React.useState<Enum[]>([]);
    const [orderStateTypes, setOrderStateTypes] = React.useState<Enum[]>([
        {
            id: -1,
            title: 'همه وضعیت',
        },
    ]);
    const [orders, setOrders] = React.useState<PaginationList<Order>>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);
    const [deleteButtonLoading, setDeleteButtonLoading] = React.useState<boolean>(false);
    const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
    const [payoutModalIsOpen, setPayoutModalIsOpen] = React.useState<boolean>(false);
    const [filterValues, setFilterValues] = React.useState<FilterValues>(empty_filters);
    const [pageSize, setPageSize] = React.useState<number>(10);
    const [selectedRows, setSelectedRows] = React.useState<Order[]>();
    const [confirmBulkActionModalIsOpen, setConfirmBulkActionModalIsOpen] =
        React.useState<boolean>(false);
    const [actionApproveLoading, setActionApproveLoading] =
        React.useState<boolean>(false);
    const [selectedActionItem, setSelectedActionItem] = React.useState<Enum>(
        actionItems[0],
    );

    const navigate = useNavigate();

    const clearFiltersHandle = () => {
        setFilterValues(empty_filters);
        filterHandle(true);
    };

    const filterHandle = (clearFilter?: boolean) => {
        var _query = '';

        if (filterValues.search) _query += `${_query.includes('?') ? '&' : '?'}keywords=${filterValues.search}`;
        if (filterValues.type?.id !== -1) _query += `${_query.includes('?') ? '&' : '?'}type=${filterValues.type?.id}`;
        if (filterValues.state?.id !== -1)
            _query += `${_query.includes('?') ? '&' : '?'}state=${filterValues.state?.id}`;
        if (filterValues.startDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}startDate=${jFormat(filterValues.startDate)}`;
        if (filterValues.endDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}endDate=${jFormat(filterValues.endDate)}`;

        setQuery(_query);

        getAllOrders(
            clearFilter ? setDeleteButtonLoading : _query !== '' ? setButtonLoading : setLoading,
            setOrders,
            1,
            pageSize,
            clearFilter ? '' : _query,
        );
    };

    React.useEffect(() => {
        confirmBulkActionModalIsOpen === false && setSelectedRows(undefined);
    }, [confirmBulkActionModalIsOpen]);

    React.useEffect(() => {
        fetches();
    }, []);

    async function fetches() {
        await getAllOrderTypes(setLoading, setOrderTypes);
        await getAllOrderStateTypes(setLoading, setOrderStateTypes);
        filterHandle();
    }

    const onPayoutIconClickHandle = React.useCallback((item) => {
        setSelectedItem(item);
        setPayoutModalIsOpen(true);
    }, []);

    const openActionConfirmModal = () => {
        setActionApproveLoading(false);
        setConfirmBulkActionModalIsOpen(true);
    };

    const columns: any[] = React.useMemo(
        () => [
            {
                name: 'شناسه',
                id: 'orderTransactionTrackingCode',
                selector: (row: Order) => row.orderTransactionTrackingCode,
                width: '14%',
                cell: (row: Order) => (
                    <span className="en copiable">
                        {row.orderTransactionTrackingCode}
                        <CopyOutlined onClick={() => copyToClipboard(row.orderTransactionTrackingCode, 'شناسه سفارش')} />
                    </span>
                ),
            },
            {
                name: 'نام',
                id: 'fullName',
                selector: (row: Order) => row.fullName,
                width: '9%',
            },
            {
                name: 'موبایل',
                id: 'phoneNumber',
                selector: (row: Order) => row.phoneNumber,
                width: '8%',
            },
            {
                name: 'جفت ارز',
                id: 'pair',
                selector: (row: Order) => row?.sourceSymbol + row.destinationSymbol,
                cell: (row: Order) => (
                    <div className="cell pair">
                        <img src={getIconPath(row.sourceSymbol.toLowerCase())} />
                        <span className="en">{row.sourceSymbol}</span>
                        {` `} / {` `}
                        <span className="en">{row.destinationSymbol}</span>
                        <img src={getIconPath(row.destinationSymbol.toLowerCase())} />
                    </div>
                ),
                width: '12%',
            },
            {
                name: 'مبلغ مبدا',
                id: 'sourceAmount',
                selector: (row: Order) =>
                    row.sourceSymbol.toLowerCase() === 'irt'
                        ? digitSperator(row.sourceAmount.toFixed(0))
                        : row.sourceAmount,
                width: '7%',
            },
            {
                name: 'مبلغ مقصد',
                id: 'destinationAmount',
                selector: (row: Order) =>
                    row.destinationSymbol.toLowerCase() === 'irt'
                        ? digitSperator(row.destinationAmount.toFixed(0))
                        : row.destinationAmount,
                width: '8%',
            },
            {
                name: 'تاریخ ثبت سفارش',
                id: 'dateTime',
                selector: (row: Order) => row?.createdOn || '',
                sortable: true,
                width: '10%',
                cell: (row: Order) => (
                    <span>
                        {moment.utc(row.createdOn).local().format('HH:mm')}{' '}
                        {moment.utc(row?.createdOn).locale('fa').local().format('YYYY/MM/DD')}{' '}
                    </span>
                ),
            },
            {
                name: 'وضعیت',
                id: 'state',
                width: '14%',
                selector: (row: Order) => row.state,
                cell: (row: Order) => (
                    <Badge text={row.state.title} type={getOrderTransactionStateBadgeType(row?.state?.id)} />
                ),
            },

            {
                name: 'نوع سفارش',
                id: 'type',
                width: '8%',
                selector: (row: Order) => row.type,
                cell: (row: Order) => (
                    <Badge
                        text={row.type.title}
                        type={row.type.title == 'موفق' ? 'success' : row.type.title == 'ناموفق' ? 'error' : 'info'}
                    />
                ),
            },

            {
                name: 'عملیات',
                id: 'action',
                width: '10%',
                cell: (row: Order) => (
                    <div className="actions">
                        <EditOutlined
                            onClick={() => {
                                setSelectedItem(row);
                                setEditModalIsOpen(true);
                            }}
                        />

                        <DollarCircleOutlined onClick={() => onPayoutIconClickHandle(row)} />

                        <InfoCircleOutlined
                            onClick={() => {
                                setSelectedItem(row);
                                setDetailModalIsOpen(true);
                            }}
                        />
                    </div>
                ),
            },
        ],
        [onPayoutIconClickHandle]
    );
    return (
        <Page className="pmx-order-transactions" title="مدیریت معاملات">
            <Modal setIsOpen={setPayoutModalIsOpen} isOpen={payoutModalIsOpen} className="confirm-payout-modal">
                <p>آیا از تایید و تسویه تراکنش کاربر {selectedItem?.fullName} اطمینان دارید؟</p>

                <div className="buttons">
                    <Button
                        type={buttonType.info}
                        text="بله"
                        onClick={() =>
                            confirmAndPayoutOrder(
                                setConfirmButtonLoading,
                                { trackingCode: selectedItem?.orderTransactionTrackingCode },
                                () => setPayoutModalIsOpen(false),
                                () => getAllOrders(setLoading, setOrders, 1, pageSize, query),
                            )
                        }
                        loading={confirmButtonLoading}
                    />
                    <Button type={buttonType.error} text="خیر" onClick={() => setPayoutModalIsOpen(false)} />
                </div>
            </Modal>
            {selectedRows && (
                <ConfirmBulkSelectModal
                    isOpen={confirmBulkActionModalIsOpen}
                    setIsOpen={setConfirmBulkActionModalIsOpen}
                    buttonLoading={actionApproveLoading}
                    selectedActionItem={selectedActionItem}
                    selectedRows={selectedRows}
                    setButtonLoading={setActionApproveLoading}
                    setSelectedRows={setSelectedRows}
                    fetchData={async () => {
                        await getAllOrders(
                            setLoading,
                            setOrders,
                            getPageNum(),
                            pageSize,
                            query,
                        );
                    }}
                    actionItem={selectedActionItem}

                />
            )}
            <Card title="معاملات" blur={loading}>
                {selectedItem && (
                    <OrderDetailModal
                        title="جزئیات معامله"
                        selectedRow={selectedItem}
                        isOpen={detailModalIsOpen}
                        setIsOpen={setDetailModalIsOpen}
                        trackingId={selectedItem?.orderTransactionTrackingCode}
                    />
                )}
                {selectedItem && orderStateTypes && (
                    <OrderEditModal
                        orderStates={orderStateTypes}
                        isOpen={editModalIsOpen}
                        setIsOpen={setEditModalIsOpen}
                        item={selectedItem}
                        onClose={() => getAllOrders(setLoading, setOrders, 1, pageSize, query)}
                    />
                )}
                <div className="filter-row">
                    <div className="fields">
                        <Input
                            value={filterValues.search}
                            className="search"
                            placeholder="جستجو کنید ..."
                            onPressEnter={filterHandle}
                            name="search"
                            onChange={(e) => setFilterValues({ ...filterValues, search: e.target.value })}
                        />

                        {orderTypes.length > 0 && (
                            <Dropdown
                                items={orderTypes}
                                onChangeHandle={(value) =>
                                    setFilterValues({
                                        ...filterValues,
                                        type: orderTypes.find((l) => l.id === value),
                                    })
                                }
                                selectedOption={filterValues.type}
                            />
                        )}
                        {orderStateTypes.length > 0 && (
                            <Dropdown
                                items={orderStateTypes}
                                onChangeHandle={(value) =>
                                    setFilterValues({
                                        ...filterValues,
                                        state: orderStateTypes.find((l) => l.id === value),
                                    })
                                }
                                selectedOption={filterValues.state}
                            />
                        )}

                        <DatePicker
                            className="date-picker"
                            value={filterValues.startDate}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.startDate}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, startDate: e.format() });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.endDate}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.endDate}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, endDate: e.format() });
                            }}
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            text="خروجی اکسل"
                            type={buttonType.info}
                            icon={<ExportOutlined />}
                            onClick={(event) => downloadCSV('معاملات', orders.items)}
                        />
                        <Button
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                            onClick={() => filterHandle()}
                        />
                        <Button
                            loading={deleteButtonLoading}
                            disabled={deleteButtonLoading}
                            text="حذف فیلتر"
                            type={buttonType.error}
                            onClick={clearFiltersHandle}
                        />
                    </div>

                </div>
                {selectedRows && selectedRows?.length > 1 && (
                    <div className="action-row">

                        <label htmlFor="">عملیات: </label>
                        <AntdDropdown
                            trigger={["click", "hover"]}
                            overlay={
                                <Menu>
                                    {actionItems &&
                                        actionItems.map((state) => (
                                            <Menu.Item onClick={() => setSelectedActionItem(state)}>
                                                {state.title}
                                            </Menu.Item>
                                        ))}
                                </Menu>
                            }
                            placement="bottom"
                        >
                            <Button
                                icon={<DownOutlined />}
                                type={buttonType.outlined}
                                text={selectedActionItem.title}
                            />
                        </AntdDropdown>
                        <Button
                            disabled={selectedActionItem.id === 0}
                            type={buttonType.info}
                            text="اصلاح تراکنش‌های انتخاب شده"
                            onClick={() => openActionConfirmModal()}
                        />
                        <Button
                            type={buttonType.outlined}
                            text={`${selectedRows?.length} آیتم انتخاب شده`}
                        />
                    </div>
                )}
                {orders?.items && orders?.items.length > 0 && (
                    <>
                        <Table
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            blur={loading}
                            setloader={setLoading}
                            getdata={getAllOrders}
                            setdata={setOrders}
                            pagination={orders.pagination}
                            className="orders-transactions-table"
                            data={orders.items}
                            column={columns}
                            filters={query}
                            selectableRows
                            onSelectRowsChange={(selected) => {
                                setSelectedRows(selected.selectedRows);
                            }}
                        />
                    </>
                )}
            </Card>
        </Page>
    );
};
